import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { getEndpoint } from 'src/app/core/services/functions.service';

export interface PeriodoMetas {
  id?: number;
  periodo: string;
  fecha_inicio: string;
  fecha_fin: string;
  estadoperiodo: string;
  usuario_creacion: string;
  fecha_creacion?: string;
  usuario_modificacion?: string;
  fecha_modificacion?: string;
  c_emp?: string;
}

export interface ApiResponse<T> {
  status: string;
  message: string;
  data: T;
}

@Injectable({
  providedIn: 'root'
})
export class PeriodosmetasService {
  ENDPOINT = getEndpoint('coms_periodos_metas');

  constructor(private http: HttpClient) { }

  getAllPeriodos(company: string): Observable<any> {
    return this.http.get<PeriodoMetas[]>(`${this.ENDPOINT}/todos/`, {
      headers: { 'company': company }
    });
  }

  getPeriodosAbiertos(company: string): Observable<ApiResponse<PeriodoMetas[]>> {
    return this.http.get<ApiResponse<PeriodoMetas[]>>(`${this.ENDPOINT}/`, {
      headers: { 'company': company }
    });
  }

  createPeriodo(periodo: PeriodoMetas): Observable<ApiResponse<PeriodoMetas>> {
    return this.http.post<ApiResponse<PeriodoMetas>>(`${this.ENDPOINT}/`, periodo, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'company': periodo.c_emp || ''
      })
    });
  }

  updatePeriodo(id: number, periodo: PeriodoMetas): Observable<ApiResponse<PeriodoMetas>> {
    return this.http.put<ApiResponse<PeriodoMetas>>(`${this.ENDPOINT}/${id}/`, periodo, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'company': periodo.c_emp || ''
      })
    });
  }

  deletePeriodo(id: number): Observable<ApiResponse<any>> {
    return this.http.delete<ApiResponse<any>>(`${this.ENDPOINT}/${id}/`, {
      headers: { 'company': 'JA' }
    });
  }

  abrirPeriodo(id: number): Observable<ApiResponse<PeriodoMetas>> {
    return this.http.put<ApiResponse<PeriodoMetas>>(`${this.ENDPOINT}/${id}/abrir/`, {}, {
      headers: { 'company': 'JA' }
    });
  }

  verificarPeriodosAbiertos(): Observable<boolean> {
    return this.http.get<{hayPeriodoAbierto: boolean}>(`${this.ENDPOINT}/verificar-abiertos/`, {
      headers: { 'company': 'JA' }
    }).pipe(
      map(response => response.hayPeriodoAbierto)
    );
  }
}